// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';
import {getDefaultState} from '../state/report-is-scrollable';

const resetReportIsScrollable = () => false;

const toggleReportIsScrollable = () => true;

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.RESET_REPORT_IS_SCROLLABLE]: resetReportIsScrollable,
        [actions.TOGGLE_REPORT_IS_SCROLLABLE]: toggleReportIsScrollable
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/shared/reducers/report-is-scrollable.js